let clickedClass = "clicked";
const body = document.body;
const lightTheme = "theme-light";
const darkTheme = "theme-dark";
let theme;

if (localStorage) {
  theme = localStorage.getItem("theme");
}

if (theme === lightTheme || theme === darkTheme) {
  if (theme === lightTheme) {
    body.classList.remove(darkTheme);
    body.classList.add(theme);
  } else {
  }
} else {
  body.classList.add(darkTheme);
  localStorage.setItem("theme", "theme-dark");
}

const switchTheme = () => {
  // Add transitioning class for smooth color transitions
  body.style.transition = "background-color 0.3s ease, color 0.3s ease";

  if (theme === lightTheme) {
    body.classList.replace(lightTheme, darkTheme);
    localStorage.setItem("theme", "theme-dark");
    theme = darkTheme;
  } else {
    body.classList.replace(darkTheme, lightTheme);
    localStorage.setItem("theme", "theme-light");
    theme = lightTheme;
  }

  // Remove forced transition after switch completes
  setTimeout(() => {
    body.style.transition = "";
  }, 500);
};

export { switchTheme, theme, clickedClass };
